import { Grid, Typography } from "@mui/material";
import React from "react";
import theme from "Theme/AppTheme";
import { observer } from "mobx-react";
import AcxSelect from "components/UI/Select/BaseSelectComponents/AcxSelect";
import { SelectedTargetFields, TargetFieldOptions } from "../../types";
import CustomOption from "../../components/CustomOption";
import { getDefaultValue } from "../../helpers/componentUtils";

type ConditionHeaderProps = {
    ruleId: string;
    showError?: boolean;
    updateTargetField: (value: string, targetFieldId: string) => void;
    targetFieldName: string;
    getUpdatedTargetFields: () => {
        targetFieldOptions: TargetFieldOptions;
        selectedTargetFields: SelectedTargetFields;
    };
};

const ConditionHeader: React.FC<ConditionHeaderProps> = observer(
    ({
        ruleId,
        showError,
        updateTargetField,
        targetFieldName,
        getUpdatedTargetFields,
    }) => {
        const { targetFieldOptions, selectedTargetFields } =
            getUpdatedTargetFields();

        const defaultValue = getDefaultValue({
            id: ruleId,
            selectedTargetFields,
            targetFieldOptions,
        });

        return (
            <Grid
                item
                container
                xs={12}
                sx={{
                    borderBottom: `1px solid ${theme.palette.gray[200]}`,
                    padding: theme.spacing(2),
                }}
            >
                <Grid
                    item
                    xs={10}
                    sx={{
                        background: theme.palette.gray[100],
                        display: "flex",
                        gap: theme.spacing(1),
                        padding: theme.spacing(1),
                        borderRadius: 2,
                        alignItems: "center",
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 600,
                            padding: theme.spacing(1),
                        }}
                    >
                        Persist to
                    </Typography>
                    <AcxSelect
                        defaultValue={defaultValue}
                        optionComponent={CustomOption}
                        id={`condition-rule-${targetFieldName}-id`}
                        placeholder="Select Target Field"
                        options={targetFieldOptions.grouped}
                        error={showError && !targetFieldName}
                        onChange={(e) => {
                            // The no selection option has an empty value
                            updateTargetField(
                                e.value === "" ? "" : e.label,
                                e.id,
                            );
                        }}
                    />
                </Grid>
            </Grid>
        );
    },
);

export default ConditionHeader;
